//开发环境
let defaultImage = {
  videoPoster:"/default/group1/M00/00/00/qizhi_kefu_default_image_videoPoster.png"
};
export default defaultImage;
